// frontend/src/pages/NotFoundPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Home, Film, Sparkles } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-romcom-pink/10 to-romcom-blue/10 flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Animated hearts */}
          <div className="flex justify-center gap-4 mb-6">
            {[...Array(3)].map((_, i) => (
              <motion.div
                key={i}
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: i * 0.3 }}
              >
                <Heart className={`fill-current text-romcom-red ${i === 1 ? 'w-12 h-12' : 'w-7 h-7 mt-3 opacity-60'}`} />
              </motion.div>
            ))}
          </div>

          {/* 404 */}
          <h1 className="text-9xl font-playfair font-bold text-romcom-red/20 mb-0 leading-none">
            404
          </h1>

          <h2 className="text-3xl font-playfair font-bold text-gray-800 mb-4 mt-4">
            This page got cold feet 💕
          </h2>

          <p className="text-gray-500 text-lg mb-8 leading-relaxed">
            Looks like this page ran off before the credits rolled. 
            Don't worry though because there are 2,000+ romcoms waiting for you!
          </p>

          {/* Action buttons */}
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="btn-primary flex items-center gap-2 px-6 py-3"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </button>
            <button
              onClick={() => navigate('/movies')}
              className="btn-secondary flex items-center gap-2 px-6 py-3"
            >
              <Film className="w-5 h-5" />
              Browse Movies
            </button>
            <button
              onClick={() => navigate('/prescriptor')}
              className="flex items-center gap-2 px-6 py-3 rounded-full border-2 border-gray-200 text-gray-600 hover:border-romcom-red hover:text-romcom-red transition-all font-medium"
            >
              <Sparkles className="w-5 h-5" />
              Get a Prescription! 
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;